import { render, staticRenderFns } from "./SubmitInstructions.vue?vue&type=template&id=20a51458&"
import script from "./SubmitInstructions.vue?vue&type=script&lang=js&"
export * from "./SubmitInstructions.vue?vue&type=script&lang=js&"
import style0 from "./SubmitInstructions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports